import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 安全解析 localStorage 中的 JSON
function getSafeLocalStorage (key, defaultValue = []) {
  const stored = localStorage.getItem(key)
  if (stored === null || stored === undefined) {
    return defaultValue
  }

  try {
    const parsed = JSON.parse(stored)
    // 确保解析结果是数组（因为 historyOrganization 应该是数组）
    return Array.isArray(parsed) ? parsed : defaultValue
  } catch (e) {
    console.warn(`Failed to parse localStorage.${key}:`, stored, e)
    return defaultValue
  }
}

// 去重函数：根据指定 key 去重，保留首次出现的项
function distinct (arr, key) {
  if (!Array.isArray(arr)) return []
  const seen = new Set()
  return arr.filter(item => {
    if (!item || typeof item !== 'object') return false
    const val = item[key]
    if (seen.has(val)) return false
    seen.add(val)
    return true
  })
}

// 初始化历史机构数据
const historyOrganizationObj = getSafeLocalStorage('historyOrganization', [])

export default new Vuex.Store({
  state: {
    currentCity: '济南市',
    historyOrganization: historyOrganizationObj,
    isLogin: false,
    issueDetail: {},
    isActive:
      window.sessionStorage.getItem('isActive') === null
        ? 'homeActive'
        : window.sessionStorage.getItem('isActive')
  },
  mutations: {
    handleIsLogin (state, payload) {
      state.isLogin = Boolean(payload)
    },
    handleIssueDetail (state, payload) {
      state.issueDetail = payload || {}
    },
    handleCurrentCity (state, payload) {
      state.currentCity = String(payload || '济南市')
    },
    handleHistoryOrganization (state, payload) {
      if (!payload || typeof payload !== 'object') {
        console.warn('Invalid organization data:', payload)
        return
      }

      // 添加到开头
      const updated = [payload, ...state.historyOrganization]
      // 去重（按 orgId）
      const uniqueList = distinct(updated, 'orgId')
      // 限制最多 12 条
      const trimmed = uniqueList.slice(0, 12)

      state.historyOrganization = trimmed
      // 安全写入 localStorage
      try {
        localStorage.setItem('historyOrganization', JSON.stringify(trimmed))
      } catch (e) {
        console.error('Failed to save historyOrganization to localStorage:', e)
      }
    }
  }
})
